import { AdaptiveColor } from '@color';
import type { Point, Size } from '@geom';
import type { MeasuredText } from '@typography';
import { immerable } from '@utils';
import { NodeLayout } from './NodeLayout';

/* ------------------------------------------------------------------ */
/*  Group-specific layout                                             */
/* ------------------------------------------------------------------ */
export class GroupLayout extends NodeLayout {
  [immerable] = true;

  color: AdaptiveColor;

  constructor(
    center: Point,
    size: Size,
    color: AdaptiveColor,
    measuredTitle?: MeasuredText,
    opacity = 1
  ) {
    super(center, size, measuredTitle, opacity);
    this.color = color;
  }
}
